import React, { useState, useEffect } from 'react'
import QRCodeGenerator from './components/QRCodeGenerator'
import Header from './components/Header'
import Footer from './components/Footer'
import './App.css'

function App() {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // Simulate loading for smooth entrance animation
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={`app ${isLoaded ? 'loaded' : ''}`}>
      <Header />
      <main className="main-content">
        <div className="container">
          <QRCodeGenerator />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default App 